module.exports = require('./helpers/bundle-url').getBundleURL('pXguj') + "logo.c5857b8b.svg";